export default __webpack_public_path__ + "static/media/sc-logo.4e1a3f1c.svg";